export default __webpack_public_path__ + "static/media/G0790.Dermatomes.1657795800000.2254f1df.jpg";